exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bgpic {\n  background: url(" + require("../pic/bgbefore.png") + ") center top no-repeat, url(" + require("../pic/bgafter.png") + ") center bottom no-repeat;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":false,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#2DB7F7","@font-size-base":"12px"}}!./src/components/pages/Login.less
// module id = 1039
// module chunks = 58